











import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store/types";
export default Vue.extend({
  name: "Question",

  props: {
    question: {
      type: Object,
      required: true
    }
  },

  components: {
    OpenQuestion: () => import("./QuestionTypes/Open.vue"),
    MultichoiceQuestion: () => import("./QuestionTypes/Multichoice.vue"),
    SinglechoiceQuestion: () => import("./QuestionTypes/Singlechoice.vue"),
    Error: () => import("@/components/Form/Error.vue")
  },

  computed: {
    ...mapState({
      error: state => (state as RootState).questionnaireError
    }),

    questionType() {
      if (this.question.isOpen) {
        return "OpenQuestion";
      } else if (this.question.isMultiChoice) {
        return "MultichoiceQuestion";
      } else {
        return "SinglechoiceQuestion";
      }
    }
  }
});
